var _jsOverlay = null;

function getJsOverlay() {
  if (!_jsOverlay) {
    _jsOverlay = document.querySelector(".js-submenu-overlay");
  }
  return _jsOverlay;
}

function createJsOverlay() {
  var desktopHeader = document.querySelector(".header-sections .desktop-header");
  if (!desktopHeader) return null;

  var el = document.createElement("div");
  el.className = "js-submenu-overlay";
  desktopHeader.appendChild(el);
  _jsOverlay = el;
  return el;
}

function getEls() {
  // Null-safe: a persistent window-scroll listener (windowScroll) can fire on
  // pages that render a different/legacy header where .header-sections — or its
  // .desktop-header / .mobile-header children — aren't in the DOM. Returning
  // safe defaults (null / empty list) lets callers bail instead of throwing
  // "Cannot read properties of null (reading 'querySelector')".
  var EMPTY = [];
  var elMain = document.querySelector(".header-sections");
  var elMainDesktop = elMain ? elMain.querySelector(".desktop-header") : null;
  var elMainMobile = elMain ? elMain.querySelector(".mobile-header") : null;
  return {
    elMain: elMain,
    elParentMenuItems: elMainDesktop
      ? elMainDesktop.querySelectorAll("ul.main-menu > .menu-item")
      : EMPTY,

    elSubmenuSections: elMainDesktop
      ? elMainDesktop.querySelectorAll("ul.main-menu .submenu-section")
      : EMPTY,
    elSubmenu: elMainDesktop
      ? elMainDesktop.querySelectorAll("ul.main-menu .submenu-section > .submenu")
      : EMPTY,

    elTopSection: elMainDesktop ? elMainDesktop.querySelector(".top-section") : null,
    elMobileMenu: elMainMobile ? elMainMobile.querySelector(".mobile-menu-inner") : null,
    elMobileMenuToggleBtn: elMainMobile ? elMainMobile.querySelector("button.menu-toggler") : null,
    elMobileSubmenus: elMainMobile ? elMainMobile.querySelectorAll(".submenu-section") : EMPTY,
    elMobileSubmenuToggleBtns: elMainMobile
      ? elMainMobile.querySelectorAll("li.menu-item button.submenu-toggler")
      : EMPTY,
  };
}

function addClass(els, ...classNames) {
  if (!els) return;

  if (NodeList.prototype.isPrototypeOf(els) || Array.isArray(els)) {
    els.forEach((el) => el.classList.add(...classNames));
  } else if (els instanceof Element) {
    els.classList.add(...classNames);
  }
}

function removeClass(els, ...classNames) {
  if (!els) return;

  if (NodeList.prototype.isPrototypeOf(els) || Array.isArray(els)) {
    els.forEach((el) => el.classList.remove(...classNames));
  } else if (els instanceof Element) {
    els.classList.remove(...classNames);
  }
}

function hasClass(els, className) {
  if (!els) return false;

  if (NodeList.prototype.isPrototypeOf(els) || Array.isArray(els)) {
    return Array.from(els).every((el) => el.classList.contains(className));
  } else if (els instanceof Element) {
    return els.classList.contains(className);
  }

  return false;
}

function addEventListeners(els, eventType, handler, options = {}) {
  if (!els) return;

  if (NodeList.prototype.isPrototypeOf(els) || Array.isArray(els)) {
    els.forEach((el) => el.addEventListener(eventType, handler, options));
  } else if (els instanceof Element) {
    els.addEventListener(eventType, handler, options);
  }
}

function overlayAnimIn(el) {
  if (!el) return;
  el.classList.remove("overlay-leaving");
  el.classList.add("overlay-visible");
  requestAnimationFrame(function () {
    el.classList.add("overlay-entering");
  });
}

function overlayAnimOut(el) {
  if (!el) return;
  el.classList.remove("overlay-entering");
  el.classList.add("overlay-leaving");

  var handler = function (ev) {
    if (ev.target !== el) return;
    el.classList.remove("overlay-visible", "overlay-leaving");
    el.removeEventListener("transitionend", handler);
  };
  el.addEventListener("transitionend", handler, { once: true });

  // Fallback if transitionend doesn't fire
  setTimeout(function () {
    el.classList.remove("overlay-visible", "overlay-leaving");
  }, 400);
}

function activateSubmenuOverlay() {
  var overlay = getJsOverlay();
  if (!overlay) return;

  // Cancel any pending deactivate
  if (activateSubmenuOverlay._deactivateTimer) {
    clearTimeout(activateSubmenuOverlay._deactivateTimer);
    activateSubmenuOverlay._deactivateTimer = null;
  }

  overlayAnimIn(overlay);
}

function deactivateSubmenuOverlay() {
  var overlay = getJsOverlay();
  if (!overlay) return;

  // Cancel any pending deactivate
  if (activateSubmenuOverlay._deactivateTimer) {
    clearTimeout(activateSubmenuOverlay._deactivateTimer);
  }

  activateSubmenuOverlay._deactivateTimer = setTimeout(function () {
    overlayAnimOut(overlay);
    activateSubmenuOverlay._deactivateTimer = null;
  }, 0);
}

function throttle(fn, limit) {
  let inThrottle;
  return function (...args) {
    if (!inThrottle) {
      fn.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

function stringToSlug(str) {
  str = str.replace(/^\s+|\s+$/g, ""); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;";
  var to = "aaaaeeeeiiiioooouuuuncescrzyuudtn------";

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str
    .replace(".", "-") // replace a dot by a dash
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by a dash
    .replace(/-+/g, "-") // collapse dashes
    .replace(/\//g, ""); // collapse all forward-slashes

  return str;
}

export {
  getEls,
  overlayAnimIn,
  overlayAnimOut,
  throttle,
  hasClass,
  addClass,
  removeClass,
  stringToSlug,
  addEventListeners,
  createJsOverlay,
  activateSubmenuOverlay,
  deactivateSubmenuOverlay,
};
